// extracted by mini-css-extract-plugin
module.exports = {"load-more-chevron":"LoadMoreButton_load-more-chevron__NDvRc"};